// @ts-nocheck
import { type GlobalElementsProps } from '../lib/types'

function GlobalFooter({ html }: GlobalElementsProps) {
  return <footer id="ge-footer" dangerouslySetInnerHTML={{ __html: html ?? '' }} />
}

export default GlobalFooter
